(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Forms = Lfl.Forms || {};

    (function (Forms, $, undefined) {
        /**
         * @memberOf Lfl.Forms
         */
        Lfl.Forms.Inputs = Forms.Inputs || {};

        (function (Inputs, $, undefined) {
            if (Lfl.Files.isLoadedAlready(Lfl.Forms.Inputs, 'Dropzone')) {
                return;
            }

            /**
             * @param {object} parameters
             * @param {string} parameters.dropzoneId
             * @param {object} parameters.dropzoneOptions
             * @param {string} parameters.fileType
             * @param {string} parameters.dropzoneName
             * @param {object} parameters.uploadHelper
             * @param {string} parameters.uploadHelper.uploadUrl
             * @param {string} parameters.uploadHelper.deleteUrl
             * @param {string} parameters.uploadHelper.moduleInstanceSlug
             * @param {int} parameters.uploadHelper.userId
             * @param {string} parameters.uploadHelper.timestamp
             * @param {array} parameters.uploadHelper.removedFileIds
             * @param {object} parameters.existingFiles
             * @param {string} parameters.submitButtonPath
             * @param {boolean} parameters.isDocumentsDropzone
             * @param {string} parameters.addIcon
             * @param {string} parameters.currentFileCountQuery
             * @param {Lfl.Files.FileExtensionIconProvider} parameters.fileExtensionIconProvider
             * @param {boolean} parameters.frontendPhotoCompressionEnabled
             * @memberOf Lfl.Forms.Inputs
             * @lends Lfl.Forms.Inputs.Dropzone
             * @constructor
             */
            Lfl.Forms.Inputs.Dropzone = function (parameters) {
                let dropzone;
                const $form = $(parameters.dropzoneId).closest('form');
                const $currentFilesCount = $(parameters.currentFileCountQuery);
                const frontendPhotoCompressionEnabled = parameters.frontendPhotoCompressionEnabled ?? true;

                const icons = {
                    addPhoto: parameters.addIcon,
                    cancelUpload: '<i class="material-icons-outlined">cancel</i>',
                    removeFile: '<i class="material-icons-outlined">close</i>',
                    error: '<i class="material-icons">error_outline</i>'
                };

                const resizeOptions = {
                    thumbnailWidth: 100,
                    thumbnailHeight: 100,
                    transformFile: convertImage
                };

                if (frontendPhotoCompressionEnabled) {
                    resizeOptions['resizeWidth'] = 4000;
                    resizeOptions['resizeHeight'] = 4000;
                    resizeOptions['resizeMethod'] = 'contain';
                    resizeOptions['resizeQuality'] = 0.8;
                }

                let defaultOptions = {
                    url: parameters.uploadHelper.uploadUrl,
                    addRemoveLinks: true,
                    autoProcessQueue: true,
                    parallelUploads: 2,
                    maxFiles: 10,
                    createImageThumbnails: false,
                    headers: {
                        "Access-Control-Allow-Origin": "*"
                    },
                    params: {
                        // TODO WIP - Add authentication to prevent third party from uploading and reading?
                        // sufficient to use Auth for tmp file storage routes? Middleware?
                        // How will authentication work with FIST::TmpFileStorageController - JABR should know.
                        // Jabr: See: Fist::SecuringUploadAndCrudOperations
                        'lflModuleInstanceSlug': parameters.uploadHelper.moduleInstanceSlug,
                        'lflUserId': parameters.uploadHelper.userId,
                        'lflTimestamp': parameters.uploadHelper.timestamp,
                        'lflFileType': parameters.fileType
                    },
                    dictDefaultMessage: icons.addPhoto,
                    dictCancelUpload: icons.cancelUpload,
                    dictRemoveFile: icons.removeFile,

                    dictCancelUploadConfirmation: Lfl.Lang.get('common/graphical_elements.dropzone.dictCancelUploadConfirmation'),
                    dictFileTooBig: Lfl.Lang.get('common/graphical_elements.dropzone.dictFileTooBig'),
                    dictInvalidFileType: Lfl.Lang.get('common/graphical_elements.dropzone.dictInvalidFileType'),
                    dictMaxFilesExceeded: Lfl.Lang.get('common/graphical_elements.dropzone.dictMaxFilesExceeded'),

                    init: onInitDropzone,
                };

                if (parameters.isDocumentsDropzone === false) {
                    defaultOptions = Object.assign(defaultOptions, resizeOptions);
                }

                const mergedOptions = Object.assign(defaultOptions, parameters.dropzoneOptions);

                // Note: Using autoDiscover = false because we initialize manually.
                // In case it is ever needed, Dropzone.option name is camelized version of HTML ID
                dropzone = new Dropzone(parameters.dropzoneId, mergedOptions);
                Dropzone.autoDiscover = false;

                this.getDropzone = function () {
                    return dropzone;
                };

                function onInitDropzone() {
                    // Register event handlers
                    this.on('success', onSuccess);
                    this.on('error', displayError);
                    this.on('removedfile', onRemovedFile);
                    this.on('complete', onComplete);

                    // Load existing files.
                    for (let id in parameters.existingFiles) {
                        // If form validation fails, dont display files those were removed + add to removedFiles[] form.
                        if (parameters.uploadHelper.removedFileIds.includes(id)) {
                            addRemovedFileToForm(id);
                        } else {
                            var existingFile = {isTmp: false, id: id};

                            if(parameters.isDocumentsDropzone) {
                                existingFile.lflFileName = parameters.existingFiles[id];
                            }

                            showFileInDropzone(
                                this,
                                existingFile,
                                parameters.isDocumentsDropzone ? null : parameters.existingFiles[id]
                            );
                            addExistingFileToForm(id);
                        }
                    }

                    // If form validation fails, display already uploaded files + add to newFiles[] form.
                    for (let lflFileName in parameters.uploadHelper.tmpFileUrls) {
                        addNewFileToForm(lflFileName);

                        const newFile = {isTmp: true, lflFileName: lflFileName, accepted: true};

                        showFileInDropzone(
                            this,
                            newFile,
                            parameters.isDocumentsDropzone ? null : parameters.uploadHelper.tmpFileUrls[lflFileName]
                        );
                    }

                    (new Lfl.Forms.DisableSubmitButtonWhenDropzoneUploadingCoordinator({
                        dropzone: this,
                        submitButtonPath: parameters.submitButtonPath
                    })).setUp();
                }

                /**
                 * @param {string} lflFileName
                 */
                function addNewFileToForm(lflFileName) {
                    $form.append(
                        '<input type="hidden" name="' + parameters.fileType + '[newFiles][]" value="' + lflFileName + '">'
                    );
                }

                /**
                 * @param {string} lflFileName
                 */
                function removeNewFileFromForm(lflFileName) {
                    $form.find('input[name="' + parameters.fileType + '[newFiles][]"][value="' + lflFileName + '"]').remove();
                }

                /**
                 * @param {int} id
                 */
                function addRemovedFileToForm(id) {
                    $form.append('<input type="hidden" name="' + parameters.fileType + '[removedFiles][]" value="' + id + '">');
                }

                /**
                 * @param {int} id
                 */
                function addExistingFileToForm(id) {
                    $form.append('<input type="hidden" name="' + parameters.fileType + '[existingFiles][]" value="' + id + '">');
                }

                /**
                 * @param {int} id
                 */
                function removeExistingFileFromForm(id) {
                    $form.find('input[name="' + parameters.fileType + '[existingFiles][]"][value="' + id + '"]').remove();
                }

                function showFileInDropzone(dz, file, thumbnailUrl) {
                    dz.displayExistingFile(file, thumbnailUrl, null, 'anonymous', false);
                }

                /**
                 * @param {string} lflFileName
                 */
                function deleteFileFromTmpStorage(lflFileName) {
                    $.post({
                        url: parameters.uploadHelper.deleteUrl,
                        data: {
                            lflFileName: lflFileName,
                            lflModuleInstanceSlug: parameters.uploadHelper.moduleInstanceSlug,
                            lflUserId: parameters.uploadHelper.userId,
                            lflTimestamp: parameters.uploadHelper.timestamp,
                            lflFileType: parameters.fileType
                        },
                        dataType: 'json'
                    });
                }

                function displayError(file, response) {
                    file.previewElement.querySelector('.dz-error-mark').innerHTML = icons.error;

                    if (file.xhr) {
                        console.error('Error occurred when uploading file: ', response);

                        $(file.previewElement).find('.dz-error-message')
                        // TODO WIP - Fist::Errors - Move to lang via passing errors to JS.
                            .text('Soubor se nepodařilo nahrát.');
                    }
                }

                function onSuccess (file, response) {
                    file.isTmp = true;
                    file.lflFileName = response.lflFileName;

                    if (parameters.isDocumentsDropzone === false) {
                        let iconUrl;

                        if ('imageThumbnailUrl' in response) {
                            iconUrl = response['imageThumbnailUrl'];
                        } else {
                            iconUrl = parameters.fileExtensionIconProvider.getIconFromFileName(file.lflFileName); //'insert_drive_file';
                        }

                        $(file.previewElement).find('.dz-image img').replaceWith(
                            '<img src="' + iconUrl + '" alt="thumbnail"/>'
                        );
                    }

                    addNewFileToForm(file.lflFileName);
                }

                function onRemovedFile (file) {
                    // Remove file preview.
                    file.previewElement.remove();

                    if (file.status === "error") {
                        // do nothing with error files
                    } else if (file.isTmp) {
                        removeNewFileFromForm(file.lflFileName);
                        deleteFileFromTmpStorage(file.lflFileName);
                        decreaseFileCount();
                    } else {
                        addRemovedFileToForm(file.id);
                        removeExistingFileFromForm(file.id);
                        decreaseFileCount();
                    }
                }

                function onComplete(file) {
                    if (file.status !== 'error') {
                        if (parameters.isDocumentsDropzone) {
                            const iconUrl = parameters.fileExtensionIconProvider.getIconFromFileName(file.lflFileName); //'insert_drive_file';

                            $(file.previewElement).find('.dz-image img').replaceWith(
                                '<img src="' + iconUrl + '" alt="file-extenstion-icon"/>'
                            );
                        }

                        increaseFileCount();
                    }
                }

                function increaseFileCount() {
                    let currentCount = parseInt($currentFilesCount.text()) + 1;
                    const maxFiles = mergedOptions.maxFiles;

                    if (currentCount > maxFiles) {
                        currentCount = maxFiles;
                    }

                    $currentFilesCount.text(currentCount);

                    if (currentCount === maxFiles) {
                        $currentFilesCount.closest('.file-count').addClass('count-exceeded');
                    }
                }

                function decreaseFileCount() {
                    let currentCount = parseInt($currentFilesCount.text()) - 1;

                    if (currentCount < 0) {
                        currentCount = 0;
                    }

                    $currentFilesCount.text(currentCount);
                    $currentFilesCount.closest('.file-count').removeClass('count-exceeded');
                }

                /**
                 * Modified function `transformFile`.
                 * Added conditional resizing
                 *
                 * @param {File} file
                 * @param {function} done
                 */
                function convertImage(file, done) {
                    if (file.type.match(/image.*/)) {
                        if (['image/heic', 'image/heif', 'image/avif', 'image/svg+xml'].includes(file.type)) {
                            done(file);
                        } else if (shouldResizeImage()) {
                            this.resizeImage(
                                file,
                                this.options.resizeWidth,
                                this.options.resizeHeight,
                                this.options.resizeMethod,
                                done
                            );
                        } else {
                            done(file);
                        }
                    } else {
                        done(file);
                    }
                }

                function shouldResizeImage() {
                    return dropzone.options.resizeWidth || dropzone.options.resizeHeight;
                }
            };
        }(Forms.Inputs, jQuery));
    }(Lfl.Forms, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
